/* eslint-disable no-useless-escape */
const REGEX_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,10}))$/i;
const REGEX_PASSWORD = /^[^\s]{6,}$/;
const REGEX_SPACE = /\s/;

export { REGEX_EMAIL, REGEX_PASSWORD, REGEX_SPACE };
